var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.type === 1)?[_c('p',{staticClass:"yx-color-pure-1 font-h4-regular"},[_vm._v("集合页")])]:_vm._l((_vm.locationList),function(item,index){return _c('p',{key:index,staticClass:"yx-color-pure-1 font-h4-regular"},[_vm._v("位置"+_vm._s(index + 1)+"： "+_vm._s(item.linkTypeDesc))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }